// extracted by mini-css-extract-plugin
export default {"mainSection":"MainSection_mainSection__-Tdhh","resultsRow":"MainSection_resultsRow__HfRBZ","pagination":"MainSection_pagination__Aew4l"};